var map = {
	"./Bsa/routes.tsx": 82610,
	"./EnergyDispatchManagement/routes.tsx": 84428,
	"./Home/routes.tsx": 74718,
	"./IndustrialGreenMicBigScreen/routes.tsx": 19573,
	"./InstructionConfig/routes.tsx": 852,
	"./MicrogridConfOverview/routes.tsx": 25795,
	"./MicrogridConfigure/routes.tsx": 80849,
	"./MicrogridStrategy/routes.tsx": 63194,
	"./SchedulingTopoDemo/routes.tsx": 6380,
	"./SchedulingTopology/routes.tsx": 57583,
	"./StrategySimulation/routes.tsx": 32040,
	"./StrategyTemplate/routes.tsx": 91593
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16860;